"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
type QuestionCardData = {
  iconSrc: string;
  iconAlt: string;
  text: string;
  date: string;
};
const QUESTION_CARD_DATA: QuestionCardData = {
  iconSrc: "https://media.dinamani.com/dinamani/2026-02-27/5749azil/Question.png",
  iconAlt: "question icon",
  text: "கட்டிடவும் வீடு நிறைவையும் தருவாயில் உள்ளது. அங்கு எப்போது குடி பேரலாம்?  கட்டிடவும் வீடு நிறைவையும் தருவாயில் உள்ளது. அங்கு எப்போது குடி பேரலாம்?  மண்ணிவாக்கத்தில் நாங்கல் கட்டிடவும் வீடு நிறைவையும் தருவாயில் உள்ளது. அங்கு எப்போது குடி பேரலாம்? ",
  date: "Wed, 17 May 2023"
};
export default function AstroQuestion() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="min-w-[50px] min-h-[50px] w-[45px] h-[45px] rounded-full bg-ECEEF3 flex items-center justify-center p-2"><Image src={QUESTION_CARD_DATA.iconSrc} alt={QUESTION_CARD_DATA.iconAlt} width={68} height={68} className="object-contain w-[40px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="w-full bg-white p-4 flex gap-4">{t0}<div className="grid grid-cols-1 gap-3"><p className="text-14-tamil-700 text-1B1B1B leading-5">{QUESTION_CARD_DATA.text}</p><p className="text-12-tamil-500 text-1B1B1B">{QUESTION_CARD_DATA.date}</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}